module.exports = __webpack_public_path__ + "static/media/cierre.d1025568.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/cierre.jpg
// module id = 208
// module chunks = 0